import MSTeamsLogo from '@atlassian/jira-icons/src/ui/ms-teams-logomark';
import ZoomLogo from '@atlassian/jira-icons/src/ui/zoom-logomark';
import msTeamImage from '../../../assets/msteamlogo.svg';
import zoomLogo from '../../../assets/zoomLogo.svg';
import type { ICommunicationConfig } from '../../types';
import messages from './messages';

export const communicationConfig: ICommunicationConfig[] = [
	{
		appName: 'Microsoft Teams',
		appIcon: msTeamImage,
		appIconComponent: MSTeamsLogo,
		appStatusEnabled: messages.enabledSetting,
		appStatusDisabled: messages.disabledSetting,
		appStatusNotConnected: messages.notConnectedText,
		adminTooltip: {
			content: messages.noMsTeamAppConnected,
			button: {
				analyticEvent: {
					name: 'getJsmAppOnTeams',
					config: {
						source: 'incidentManagementSettingsScreen',
					},
				},
				href: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
				text: messages.connectTeamApp,
			},
		},
		tooltip: {
			content: messages.contactAdminToolTip,
			button: {
				analyticEvent: {
					name: 'contactJiraAdmin',
					config: {
						source: 'incidentManagementSettingsScreen',
						cause: 'MsTeamsJsmConnection',
					},
				},
				href: '/jira/contact-administrator',
				text: messages.contactJiraAdmin,
			},
		},

		toogle: {
			label: messages.enabledDisabledAriaLabel,
		},
	},
	{
		appName: 'Zoom',
		appIcon: zoomLogo,
		appIconComponent: ZoomLogo,
		appStatusEnabled: messages.enabledSetting,
		appStatusDisabled: messages.disabledSetting,
		appStatusNotConnected: messages.notConnectedText,
		adminTooltip: {
			content: messages.noZoomAppConnected,
			button: {
				analyticEvent: {
					name: 'getJsmAppOnZoom',
					config: {
						source: 'incidentManagementSettingsScreen',
					},
				},
				href: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
				text: messages.connectZoomApp,
			},
		},
		tooltip: {
			content: messages.contactAdminZoomToolTip,
			button: {
				analyticEvent: {
					name: 'contactJiraAdmin',
					config: {
						source: 'incidentManagementSettingsScreen',
						cause: 'ZoomJsmConnection',
					},
				},
				href: '/jira/contact-administrator',
				text: messages.contactJiraAdmin,
			},
		},

		toogle: {
			label: messages.enabledDisabledAriaLabel,
		},
	},
];
